module.exports = __webpack_public_path__ + "img/L6.b6d6176.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/cooperation/banner/L6.jpg
// module id = hvbV
// module chunks = 0